export class UIUtilities {
    public static smoothScrollTo(element: Element | string, forceScroll: boolean = true, offset: number = 0): void {
        let targetElement: Element | null = null;

        if (typeof element === 'string') {
            targetElement = document.querySelector(element);
        } else {
            targetElement = element;
        }

        if (targetElement) {
            const rect = targetElement.getBoundingClientRect();
            const destinationY = window.pageYOffset + rect.top - 100 - offset;

            if (forceScroll || (window.pageYOffset < destinationY - window.innerHeight || window.pageYOffset > destinationY)) {
                // Use native smooth scrolling
                window.scrollTo({
                    top: destinationY,
                    behavior: 'smooth'
                });
            }
        }
    }

    public static slideUp(element: HTMLElement, duration: number = 500): void {
        element.style.transitionProperty = "height, margin, padding";
        element.style.transitionDuration = duration + "ms";
        element.style.boxSizing = "border-box";
        element.style.height = element.offsetHeight + "px";
        element.offsetHeight; // Force reflow
        element.style.overflow = "hidden";
        element.style.height = "0";
        element.style.paddingTop = "0";
        element.style.paddingBottom = "0";
        element.style.marginTop = "0";
        element.style.marginBottom = "0";

        window.setTimeout(() => {
            element.style.display = "none";
            element.style.removeProperty("height");
            element.style.removeProperty("padding-top");
            element.style.removeProperty("padding-bottom");
            element.style.removeProperty("margin-top");
            element.style.removeProperty("margin-bottom");
            element.style.removeProperty("overflow");
            element.style.removeProperty("transition-duration");
            element.style.removeProperty("transition-property");
        }, duration);
    }

    public static slideDown(element: HTMLElement, duration: number = 500): void {
        element.style.removeProperty("display");
        var displayStyle = window.getComputedStyle(element).display;
        
        if (displayStyle === "none") {
            displayStyle = "block";
        }
        
        element.style.display = displayStyle;
        var height = element.offsetHeight;
        
        element.style.overflow = "hidden";
        element.style.height = "0";
        element.style.paddingTop = "0";
        element.style.paddingBottom = "0";
        element.style.marginTop = "0";
        element.style.marginBottom = "0";
        element.offsetHeight; // Force reflow
        element.style.boxSizing = "border-box";
        element.style.transitionProperty = "height, margin, padding";
        element.style.transitionDuration = duration + "ms";
        element.style.height = height + "px";
        element.style.removeProperty("padding-top");
        element.style.removeProperty("padding-bottom");
        element.style.removeProperty("margin-top");
        element.style.removeProperty("margin-bottom");

        window.setTimeout(() => {
            element.style.removeProperty("height");
            element.style.removeProperty("overflow");
            element.style.removeProperty("transition-duration");
            element.style.removeProperty("transition-property");
        }, duration);
    }

    public static initSwitchList(): void {
        console.log("entered switchlist");
        document.querySelectorAll(".box").forEach((box) => {
            box.querySelectorAll(".circle span").forEach((span) => {
                span.addEventListener("click", () => {
                    if (box.classList.contains("active")) {
                        box.classList.remove("active");
                        const infoBox = document.querySelector(`.info_box[data-item='${(box as HTMLElement).dataset.item}']`) as HTMLElement;
                        if (infoBox) {
                            UIUtilities.slideUp(infoBox, 300);
                        }
                    } else {
                        document.querySelectorAll(".box").forEach((b) => b.classList.remove("active"));
                        document.querySelectorAll(".info_box").forEach((infoBox) => {
                            UIUtilities.slideUp(infoBox as HTMLElement, 100);
                        });
                        
                        box.classList.add("active");
                        
                        setTimeout(() => {
                            const infoBox = document.querySelector(`.info_box[data-item='${(box as HTMLElement).dataset.item}']`) as HTMLElement;
                            if (infoBox) {
                                UIUtilities.slideDown(infoBox, 300);
                            }
                        }, 100);
                    }
                });
            });
        });
    }
}
